// @flow
import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';



// components
import AccountLayout from './AccountLayout';

import logoutIcon from '../../assets/images/logout-icon.svg';

/* bottom link */
const BottomLink = () => {
   
    return (
        <Row className="mt-3">
            <Col className="text-center">
                <p className="text-muted">
                    {'Back to '}{' '}
                    <Link to={'/'} className="text-muted ms-1">
                        <b>{'Log In'}</b>
                    </Link>
                </p>
            </Col>
        </Row>
    );
};

const Logout = ():any => {
 
    return (
        <>
            <AccountLayout bottomLinks={<BottomLink />}>
                <div className="text-center w-75 m-auto">
                    <h4 className="text-dark-50 text-center mt-0 fw-bold">{'See You Again !'}</h4>
                    <p className="text-muted mb-4">{'You are now successfully sign out.'}</p>

                    <div className="logout-icon m-auto">
                        <img src={logoutIcon} alt="" />
                    </div>
                </div>
            </AccountLayout>
        </>
    );
};

export default Logout;
